import React, { useRef } from 'react';

import PageSideBarNavigation from '../../../../../PageSideBarNavigation';

export default function FinanceSide() {
  const links = useRef([
    { to: '/finance/overview', text: 'Overview' },
    { to: '/finance/contracts', text: 'Contracts' },
  ]);

  return <PageSideBarNavigation links={links.current} />;
}
